export const iconFontAwesomeTravelHotelBusSimple = (
	<i className="fa-solid fa-bus-simple"></i>
);
